
<template>
  <div class="hello" style="padding-top:0px;padding-bottom:20px;">
    <think-list-component v-on:selectThink ="NavigateWordsPage"></think-list-component>
    <!-- {{this.$store.state.loginUser}}
    {{this.$store.state.loginUser.providerData[0].providerId}} -->
  </div>
</template>

<script>
import Title from "../atoms/Title";
import Words from "../Words";
import ThinkList from "../ThinkList";
export default {
  name: "WordsPage",
  components: {
    "think-list-component": ThinkList
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      from: ""
    };
  },

  computed: {
    thinkData() {
      return this.$store.getters.thinkData;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from.path;
      // Notice: ログインページからの遷移、当ページリロードの場合、itemが０の場合のみデータを取得する
      // ＊不必要にデータを取得して、リストのちらつきをおさえるのが目的
      if (
        from.path === "/" ||
        from.path === "/login" ||
        vm.$store.getters.thinkItems.length == 0
      ) {

        var callback = function(result,msg) {}
        console.log("beforeRouterEnter: GetThinks")
        vm.$store.dispatch("GetThinks",{callback:callback});
      }

      
    });
  },
  methods: {
    NavigateWordsPage(item) {
      //選択したデータをストアにセット
      this.$store.commit("SetThink", item);
      //ページ遷移
      this.$router.push({ name: "WordsPage",params:{thinkID:item.id} });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ThinksPage.vue